// src/context/Notifications/alertOverrides.ts

/**
 * Live cut/tamper state is a session-scoped latch. The device-data-api owns
 * the durable latch across reloads; this cache only prevents a later benign
 * frame or stale response from repainting the current browser session secure.
 */
export type DeviceAlertOverrides = Record<string, true>;

export const setOverride = (
  prev: DeviceAlertOverrides,
  deviceId: string
): DeviceAlertOverrides => {
  if (!deviceId) return prev;
  if (prev[deviceId]) return prev;
  return { ...prev, [deviceId]: true };
};

export const isAlerting = (
  overrides: DeviceAlertOverrides,
  deviceId: string | null | undefined
): boolean => {
  if (!deviceId) return false;
  return overrides[deviceId] === true;
};
